import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { NgxToolbarComponent } from './toolbar.component';
import { NgxToolbarButtonComponent } from './toolbar-button/toolbar-button.component';

export const ngxToolbarModule = angular.module('ngxToolbarModule', [])
	.directive('ngxToolbar', downgradeComponent({ component: NgxToolbarComponent }))
	.directive('ngxToolbarButton', downgradeComponent({ component: NgxToolbarButtonComponent }))
	.name;
